module.exports = "<video *ngIf=\"videoSrc\" controls>\r\n    <source src=\"{{ videoSrc }}\" type=\"video/mp4\" />\r\n</video>\r\n";